export default {
  txNumberCopied: "Transaction number copied.",
  deposit: {
    successRialDeposit: "Your Rial deposit was successful.",
    trxNumber: "Transaction Number",
    referCode: "Reference Code",
    trackingCode: "Tracking Code",
    payAmount: "Payment Amount",
    registerDate: "Registration Date and Time",
    trxStatus: "View Transaction Status",
    goToWallet: "Go to Wallet Page",
    suspendTrx: "Transaction Suspended",
    successTrx:
      "Your transaction was registered and your payment was successful in the bank. However, the card number you paid with was not previously registered in your account. Therefore, your transaction needs to be reviewed. For more information, you can contact Excoino support.",
    addCard: "Register Bank Card",
    unsuccessfulTrx: "Unsuccessful",
    depositAgain: "Deposit Again",
    offlineDeposit: {
      registerInfo:
        "Your offline deposit information was successfully registered",
      increaseRialBalance:
        "After review and approval of the deposit, your Rial balance will be increased.",
      depositAmount: "Deposit Amount",
      registerDate: "Registration Date and Time",
      sourceBank: "Source Bank",
      depositType: "Deposit Type",
      trackingCode: "Tracking Code",
      status: "Status",
      goToWallet: "Go to Wallet"
    },
    resubmitDeposit: {
      confirmOrder: "Confirm Order",
      dueTime: "Your time to complete this order",
      trxNumber: "Transaction Number",
      payAmount: "Payment Amount",
      selectGateWay: "Select Gateway",
      cancelOrder: "Cancel Order",
      goToGateWay: "Go to Gateway"
    }
  },
  transfer: {
    transfer: "You are transferring",
    tokenType: "Currency Type",
    continueProcess: "Continue the Transfer Process",
    registeredRequest: "Your request was successfully registered.",
    excoinoConfirmation:
      "After confirmation by Excoino, your order will be completed.",
    trxNumber: "Transaction Number",
    registeredDate: "Registration Date and Time",
    amount: "Amount",
    goToWallet: "Go to Wallet",
    goToMarket: "Go to Excoino Market",
    prevStep: "Go to Previous Step",
    cancelOrder: "Cancel Order"
  },
  withdrawal: {
    cancelOrder: "Cancel Order",
    crypto: {
      youSend: "You are sending",
      tokenType: "Currency Type",
      destAddress: "Destination Wallet Address",
      networkType: "Network Type",
      withoutDeductionOfFee: "Amount without deduction of fee",
      fee: "Fee",
      continueProcess: "Continue Withdrawal Process",
      registeredSuccessful: "Your request was successfully registered",
      excoinoConfirm:
        "After confirmation by Excoino, your order will be completed.",
      trxNumber: "Transaction Number",
      amount: "Amount",
      registerDate: "Registration Date and Time",
      trxStatus: "View Transaction Status",
      goToWallet: "Go to Wallet"
    },
    rial: {
      successWithdraw: "Your withdrawal request was successfully registered.",
      excoinoConfirm:
        "After confirmation by Excoino, your order will be completed.",
      trxNumber: "Transaction Number",
      amount: "Amount"
    }
  }
};
